export async function copyEventLink(eventId: string): Promise<void> {
	const url = new URL(window.location.href);
	url.hash = eventId;
	await navigator.clipboard.writeText(url.toString());
}
